<template>
  <el-dialog width="1300px" top="6vh" :destroy-on-close="true">
    <div class="a">
      <div class="a-title">添加商品</div>
      <div class="p">
        <div class="p-top">
          <span>商品搜索</span>
          <el-input
            v-model="value"
            :rows="1"
            type="textarea"
            placeholder="请输入您想查询的信息"
            style="width: 300px"
            @keydown.enter="search"
          />
          <div style="margin-left: 20px; display: flex">
            <el-button size="mini" type="primary" @click="search">查询</el-button>
            <div style="color: #999999; margin-left: 20px; font-size: 12px">
              批量添加订货号（型号）和数量，用空格隔开，也可从Excel中复制粘贴，然后按查询。
            </div>
          </div>
        </div>
        <!-- 商品信息 -->
        <lida-table
          ref="table"
          :pagination="false"
          :cutHeight="150"
          :data="data"
          border
          @selection-change="selectGoods"
        >
          <el-table-column :selectable="checkSelectable" type="selection" width="55" fixed />
          <lida-table-column label="产品信息" fixed>
            <template #default="scope">
              <div class="g-info">
                <div class="g-icon">
                  <img :src="scope.row.src" />
                </div>
                <div class="g-right">
                  <div class="g-r-title">
                    {{ scope.row.productName }}
                    <div class="label" :title="scope.row.brandName">{{ scope.row.brandName }}</div>
                  </div>
                  <div class="g-r-data">
                    {{ scope.row.barCode || '无' }}
                    <span>|</span>
                    {{ scope.row.seriesName || '无' }}
                    <span>|</span>
                    {{ scope.row.skuNumber || '无' }}
                  </div>
                </div>
              </div>
            </template>
          </lida-table-column>
          <lida-table-column label="订货号" prop="articleNo" />
          <lida-table-column label="面价" prop="guidePrice" />
          <lida-table-column label="操作" fixed="right">
            <template #default="scope">
              <el-button size="mini" type="text" @click="deleteRow(scope)">移除</el-button>
            </template>
          </lida-table-column>
        </lida-table>
      </div>
      <div class="a-footer">
        <el-button style="margin-right: 20px" size="mini" @click="close">取消</el-button>
        <el-button style="margin-left: 20px" type="primary" size="mini" @click="confirm">确认</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import { ElMessage } from 'element-plus'

export default {
  props: {
    ids: {
      type: Array,
      default: () => []
    },
    parentId: {
      type: [String, Number],
      default: ''
    },
    emptionType: {
      type: String,
      default: '0'
    }
  },
  data() {
    return {
      value: '',
      data: []
    }
  },
  methods: {
    ...mapActions('purchaseMudule', ['skuPage']),
    ...mapActions('myMessageModule', ['userCreateEmption']),
    search() {
      if (this.value) {
        this.skuPage({
          wd: this.value,
          pageNo: 1,
          pageSize: 30
        }).then(res => {
          const { code, data } = res.data
          if (code === '0') {
            data.rows.map(item => {
              item.qty = 1
              item.manufactureDate = ''
              item.channel = ''
              item.purchasePrice = ''
              item.profitSite = ''
              item.guideSite = ''
              item.guidePrice = item.guidePrice.toFixed(2)
              item.disabled = this.ids.some(v => v === item.id)
              item.purchaseDis = ''
              item.salesDis = ''
              item.salesPrice = ''
              item.profitC = ''
            })
            this.data = data.rows
          }
        })
      } else {
        ElMessage({
          type: 'warning',
          message: '请输入查询条件'
        })
      }

      const e = window.event || arguments[0]
      if (e.key === 'Enter' || e.code === 'Enter' || e.keyCode === 13) {
        e.returnValue = false
        return false
      }
    },
    deleteRow(obj) {
      this.data.splice(obj.$index, 1)
    },
    close() {
      this.$emit('update:modelValue', false)
    },
    confirm() {
      let data = JSON.parse(JSON.stringify(this.data.filter(v => !v.disabled)))
      data = data.filter(v => v.active)
      if (data.length) {
        const ids = []
        data.map(item => {
          ids.push(item.id)
          delete item.disabled
        })
        const params = {
          type: this.emptionType,
          skuIds: ids
        }
        if (this.parentId) {
          params.parentId = this.parentId
        }
        this.userCreateEmption(params).then(res => {
          const { code } = res.data
          if (code === '0') {
            ElMessage({
              type: 'success',
              message: '新增成功'
            })
            this.$refs.table.$refs.lidaTable.clearSelection()
            this.close()
            this.$emit('success')
          }
        })
      } else {
        ElMessage({
          type: 'warning',
          message: '请选择要添加的商品'
        })
      }
    },
    selectGoods(data) {
      this.data.map(item => {
        item.active = data.some(v => v.id === item.id)
      })
    },
    checkSelectable(row) {
      return !row.disabled
    }
  }
}
</script>

<style scoped lang="less">
.a {
  padding: 20px;
  .a-title {
    padding-bottom: 20px;
    font-weight: bold;
  }
  .a-footer {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 20px;
  }
}
.p {
  .p-top {
    display: flex;
    align-items: center;
    padding-bottom: 20px;
    span {
      white-space: nowrap;
      margin-right: 10px;
    }
  }
}
</style>
